import { render, staticRenderFns } from "./ButtonAssignment.vue?vue&type=template&id=357556af&scoped=true&"
import script from "./ButtonAssignment.vue?vue&type=script&lang=js&"
export * from "./ButtonAssignment.vue?vue&type=script&lang=js&"
import style1 from "./ButtonAssignment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357556af",
  null
  
)

export default component.exports